import { render, staticRenderFns } from "./UserReviewIcon.vue?vue&type=template&id=af70c5d8"
import script from "./UserReviewIcon.vue?vue&type=script&lang=ts"
export * from "./UserReviewIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports